export default "__VITE_ASSET__76cc25c7__"